import useMapboxQuery from './useMapboxQuery';

export interface ISearchSuggestion {
  label: string;
  value?: unknown;
  url?: string;
  sublabel?: string;
}

export const useLocationSearchSuggestions = (
  text: string,
  location?: number[],
  types = 'country,region,postcode,district,place,locality,neighborhood,address',
): ISearchSuggestion[] => {
  const places = useMapboxQuery(
    text.length < 3
      ? null
      : {
          text: text,
          ...(location ? { location: location } : {}),
          types: types,
        },
  );

  return places.map(p => ({
    label: 'place_name' in p ? p.place_name : p.name_preferred || p.name,
    sublabel: 'place_formatted' in p ? p.place_formatted || p.full_address : '',
    value: p,
  }));
};
